<template lang='pug'>
  .products-index-bestsellers-carousel.clearfix(v-if='products.length > 0')
    ProductsCarousel(
      :carousel-options='carouselOptions'
      :entity-options='entityOptions'
      :products='products'
      :variants='variants'
      autoplay
    )
</template>

<script>
import { mapState } from 'vuex'
import ProductsCarousel from '../../products/products-carousel.vue'

export default {
  components: {
    ProductsCarousel
  },

  data () {
    return {
      carouselOptions: {
        perPage: 3,
        arrowOut: true,
        portrait: 1,
        type: 'batch',
        autorun: true,
        size: 'md'
      },
      entityOptions: {
        type: 'bestsellers',
        title: this.$t('products.productGroup.bestSellers')
      }
    }
  },

  computed: {
    ...mapState({
      entitySlug: state => state.product.entitySlug,
      products: state => state.product.bestsellerProducts,
      variants: state => state.product.bestsellerVariants
    })
  }
}
</script>

<style lang='scss'>
  .products-index-bestsellers-carousel {
    @include media-breakpoint-up(sm) {
      border-bottom: 1px solid $grey;
      margin-bottom: 15px;
    }

    @include media-breakpoint-down(sm) {
      display: flex;
      flex-direction: column;
      padding-top: 20px;
    }

    .wrapper {
      padding-bottom: 40px;
    }

    .page-title {
      @include font-sephora-sans;
      @include font-weight-bold;
      text-transform: uppercase;
      font-size: 25px;
    }
  }
</style>
